import { jsx } from "react/jsx-runtime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { validateTidalLicense } from "../../base/index.js";
function Assignment(props) {
  return /* @__PURE__ */ jsx(
    AssignmentIcon,
    {
      "data-testid": "Assignment",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Assignment",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Assignment.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Assignment"
};
validateTidalLicense();
export {
  Assignment
};
//# sourceMappingURL=Assignment.js.map
